// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__AxHlR","box__row":"styles_box__row__uzTRy","skeleton-animation":"styles_skeleton-animation__h34Xn"};